export const allTrackedTimeTypes = ["SwiipeRelatedIssue", "Onboarding", "FeatureImplementation", "Debugging", "Other"] as const
export type ETrackedTimeType = (typeof allTrackedTimeTypes)[number]
export const defaultTrackedTimeType: ETrackedTimeType = "Onboarding"
